<div class="homr-banner-content" [class.hmf-display-none]="bannerInfo() === false">
  <div class="skeleton-container"
    [class.hmf-display-flex]="bannerInfo() && !contentLoaded()"
    [class.hmf-flex-column]="bannerInfo() && !contentLoaded()"
    [class.hmf-justify-content-between]="bannerInfo() && !contentLoaded()"
    [class.hmf-display-none]="bannerInfo() && contentLoaded()">
    <div class="hmf-m-xs skeleton-grey-loading-box big"></div>
  </div>

  @defer {
    <div #templateOutlet></div>
  }
</div>
